import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { FaEdit, FaRegWindowClose, FaPencilAlt } from 'react-icons/fa';
import FormTemplate from '../../../components/FormTemplate';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { EditorState, ContentState } from 'draft-js';
import { MODE_VIEW, MODE_EDIT, DATE_FORMAT, SUCCESS, SUBSCRIBED, UNSUBSCRIBED, SUCCESS_BUTTON, NO, YES, SECONDARY, PRIMARY, UPDATE, SAVE, SPACE_STRING, CANCEL } from '../../../../utils/constants';
import { announcementOperations, announcementSelectors } from '../state';
import htmlToDraft from 'html-to-draftjs';
import moment from 'moment';
import { MSG_CONFIRM_CHANGES, SAVE_CHANGES } from '../../../../utils/messages';
import ConfirmationModal from '../../../components/ConfirmationModal';
import debounce from 'lodash.debounce';
import { isNullOrUndefined } from 'util';

class BannerTab extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            mode: MODE_VIEW,
            editorState: EditorState.createEmpty(),
            prevEditorState: null,
            editorStateTwo: EditorState.createEmpty(),
            prevEditorStateTwo: null,
            initialAnnouncementDetails: null,
            anouncementDetails: null,
            showSaveModal: false
        }

        //Required to make submission possible on external button
        this.submitForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
    }

    componentDidMount() {
        this.props.getBannerAnnouncements(this.props.isSubscribed)
            .then((response) => {

                if (undefined !== response) {
                    
                    let banner = {};
                    let generic = response.data.genericAnnouncement;
                    let timebound = response.data.timeboundAnnouncement;
                    timebound.startDate = isNullOrUndefined(timebound.startDate) ? moment() : moment(timebound.startDate).format(DATE_FORMAT);
                    timebound.endDate = isNullOrUndefined(timebound.endDate) ? moment() : moment(timebound.endDate).format(DATE_FORMAT);

                    //set initial data for timebound
                    banner.title = timebound.title;
                    banner.startDate = timebound.startDate;
                    banner.endDate = timebound.endDate;
                    banner.message = timebound.message;
                    //set initial data for generic
                    banner.announcementTitle = generic.announcementTitle;
                    banner.announcementMessage = generic.announcementMessage;

                    //generic editor
                    let contentStateGeneric = null;
                    let blocksFromHtmlGeneric = htmlToDraft(generic.announcementMessage);
                    let contentBlocksGeneric = blocksFromHtmlGeneric.contentBlocks;
                    let entityMapGeneric = blocksFromHtmlGeneric.entityMap;
                    contentStateGeneric = ContentState.createFromBlockArray(contentBlocksGeneric, entityMapGeneric);

                    //timebound editor
                    let contentStateTimebound = null;
                    timebound.message = isNullOrUndefined(timebound.message) ? "" : timebound.message;
                    let blocksFromHtmlTimebound = htmlToDraft(timebound.message);
                    let contentBlocksTimebound = blocksFromHtmlTimebound.contentBlocks;
                    let entityMapTimebound = blocksFromHtmlTimebound.entityMap;
                    contentStateTimebound = ContentState.createFromBlockArray(contentBlocksTimebound, entityMapTimebound);

                    this.setState({
                        initialAnnouncementDetails: { BannerModel: banner },
                        editorState: EditorState.createWithContent(contentStateTimebound),
                        prevEditorState: EditorState.createWithContent(contentStateTimebound),
                        editorStateTwo: EditorState.createWithContent(contentStateGeneric),
                        prevEditorStateTwo: EditorState.createWithContent(contentStateGeneric)
                    })
                }

            })
    }

    updateEditorState = (editorState) => {
        this.setState({ editorState })
    }

    updateEditorStateTwo = (editorStateTwo) => {
        this.setState({ editorStateTwo })
    }

    onSubmitClick = () => {
        this.form.submitForm();
    }

    onCancelClick = () => {
        this.form.resetForm(this.state.initialAnnouncementDetails);
        this.setState(prevState => ({
            editorState: prevState.prevEditorState,
            editorStateTwo: prevState.prevEditorStateTwo,
            mode: MODE_VIEW
        }))
    }

    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    renderRightButtons = () => {
        if (MODE_EDIT === this.state.mode) {
            return (
                <div>
                    <Button variant={SECONDARY} style={{ marginRight: 8 }} onClick={this.onCancelClick}>
                        <FaRegWindowClose className="banner-buttons" />
                        {SPACE_STRING + CANCEL}
                    </Button>
                    <Button variant={SUCCESS_BUTTON} onClick={this.onSubmitClick}>
                        <FaPencilAlt className="banner-buttons" />
                        {SPACE_STRING + SAVE}
                    </Button>
                </div>
            )
        } else {
            return (
                <Button variant={PRIMARY} onClick={() => this.setState({ mode: MODE_EDIT })}>
                    <FaEdit className="banner-buttons" />
                    {SPACE_STRING + UPDATE}
                </Button>
            )
        }

    }

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    handleSubmit = (values) => {

        let announcementMessage = values.BannerModel.announcementMessage
        let message = values.BannerModel.message

        //generic editor
        let contentStateGeneric = null;
        let blocksFromHtmlGeneric = htmlToDraft(announcementMessage);
        let contentBlocksGeneric = blocksFromHtmlGeneric.contentBlocks;
        let entityMapGeneric = blocksFromHtmlGeneric.entityMap;
        contentStateGeneric = ContentState.createFromBlockArray(contentBlocksGeneric, entityMapGeneric);

        //timebound editor
        let contentStateTimebound = null;
        message = isNullOrUndefined(message) ? "" : message;
        let blocksFromHtmlTimebound = htmlToDraft(message);
        let contentBlocksTimebound = blocksFromHtmlTimebound.contentBlocks;
        let entityMapTimebound = blocksFromHtmlTimebound.entityMap;
        contentStateTimebound = ContentState.createFromBlockArray(contentBlocksTimebound, entityMapTimebound);

        this.setState({
            anouncementDetails: values,
            editorState: EditorState.createWithContent(contentStateTimebound),
            prevEditorState: EditorState.createWithContent(contentStateTimebound),
            editorStateTwo: EditorState.createWithContent(contentStateGeneric),
            prevEditorStateTwo: EditorState.createWithContent(contentStateGeneric)
        }, () => this.toggleSave());
    }

    saveChanges = () => {
        let values = this.state.anouncementDetails.BannerModel;
        let genericAnnouncement = {};
        let timeboundAnnouncement = {};

        genericAnnouncement.announcementTitle = values.announcementTitle;
        genericAnnouncement.announcementMessage = values.announcementMessage;
        genericAnnouncement.subscribed = this.props.isSubscribed;
        timeboundAnnouncement.title = values.title;
        timeboundAnnouncement.message = values.message;
        timeboundAnnouncement.startDate = moment(values.startDate);
        timeboundAnnouncement.endDate = moment(values.endDate);
        timeboundAnnouncement.subscribed = this.props.isSubscribed;

        this.props.updateBannerAnnouncement(genericAnnouncement, timeboundAnnouncement, this.props.isSubscribed)
            .then(response => {
                if (SUCCESS === response.status) {
                    this.setState({ mode: MODE_VIEW, showSaveModal: false, initialAnnouncementDetails: { BannerModel: values } })
                }
            })
    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    render() {
        return (
            <Card style={{ marginTop: 12 }}>
                <div className="flex-search">
                    <h5>{`For ${this.props.isSubscribed ? SUBSCRIBED : UNSUBSCRIBED} Members`}</h5>
                    {this.renderRightButtons()}
                </div><br />

                <FormTemplate
                    {...this.props}
                    validate={announcementSelectors.validateBannerForm}
                    editMode={MODE_VIEW === this.state.mode}
                    readOnly={MODE_VIEW === this.state.mode}
                    initialValues={this.state.initialAnnouncementDetails}
                    editorState={this.state.editorState}
                    editorStateTwo={this.state.editorStateTwo}
                    updateEditorState={this.updateEditorState}
                    updateEditorStateTwo={this.updateEditorStateTwo}
                    bindSubmitFormik={this.bindSubmitFormik}
                    handleSubmit={this.handleSubmit}
                    updateFormRef={this.updateFormRef}
                />

                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />
            </Card>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        formInputs: state.announcements.bannerForm
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getBannerAnnouncements: announcementOperations.getBannerAnnouncements,
        updateBannerAnnouncement: announcementOperations.updateBannerAnnouncement
    },
    dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(BannerTab);